import React from 'react';
import { ThemeProvider } from 'styled-components';
import DirectionProvider from '@veneer/core/dist/scripts/direction/direction_provider';
import { ThemeProvider as VeneerThemeProvider } from '@veneer/theme';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { theme } from './utils/styleHelpers';
import { RTL_LANG } from './constants/i18n';
import { getLocale } from './utils/determineLocale';
import { useThemeHook } from './utils/OSThemeHelpers';
import UpdateContainer from './SmartWelcome/UpdateContainer';
import WelcomeContainer from './SmartWelcome/WelcomeContainer';

const App = ({ currentStack }) => {
  const [mode] = useThemeHook();
  const { language } = getLocale();
  const direction = RTL_LANG.includes(language) ? 'rtl' : 'ltr';

  return (
    <Router>
      <VeneerThemeProvider mode={mode}>
        <DirectionProvider direction={direction}>
          <ThemeProvider theme={theme}>
            <Switch>
              <Route path="/in-app/:platform/welcome">
                <WelcomeContainer currentStack={currentStack} />
              </Route>
              <Route path="/in-app/:platform/:version/user-consents">
                <WelcomeContainer reTarget currentStack={currentStack} />
              </Route>
              <Route path="/in-app/:platform/:version/user-consents-update">
                <UpdateContainer consentsUpdate currentStack={currentStack} />
              </Route>
              <Route path="/in-app/:platform/printer-data">
                {({
                  match: {
                    params: { platform }
                  },
                  location
                }) => (
                  <Redirect to={`/in-app/${platform}/v1_0/printer-consents${location.search}`} />
                )}
              </Route>
              <Route path="/in-app/:platform/:version/printer-consents">
                <WelcomeContainer printerWelcome reTarget currentStack={currentStack} />
              </Route>
              <Route path="/in-app/:platform/:version/printer-consents-update">
                <UpdateContainer consentsUpdate currentStack={currentStack} />
              </Route>
            </Switch>
          </ThemeProvider>
        </DirectionProvider>
      </VeneerThemeProvider>
    </Router>
  );
};

export default App;
